import Vue from "vue";

import { URL_API } from "../../settings/apiConnect";

export default {
    actions: {
        async getExpansionsData(context) {
            const response = await Vue.axios.get(`${URL_API}expansion`);
            let data = response["data"];
            context.commit("updateExpansionsData", data);
        },
        async createExpansionData(context, name) {
            const config = {};
            const body = {
                name: name
            };
            await Vue.axios.post(`${URL_API}expansion/store`, body, config);
            context.dispatch("getExpansionsData");
        },
        async pushExpansionData(context, { id, name }) {
            const config = {};
            const body = {
                id: id,
                name: name
            };
            await Vue.axios.post(`${URL_API}expansion/update`, body, config);
            context.dispatch("getExpansionsData");
        },
        async destroyExpansionData(context, id) {
            const config = {};
            const body = {
                id: id
            };
            await Vue.axios.post(`${URL_API}expansion/destroy`, body, config);
            context.dispatch("getExpansionsData");
        }
    },
    mutations: {
        updateExpansionsData(state, expansionsData) {
            state.expansionsData = expansionsData;
        }
    },
    state: {
        expansionsData: []
    },
    getters: {
        allExpansionsData(state) {
            return state.expansionsData;
        }
    }
};